const initialState = () => ({
  page: 1,
  disbursment_status: "Disbursement Approval Pending",
  selected_tab: 0,
  display_daterange: null,
  date_range: [],
  initaited_by: "",
  city: "",
  executive_type: "",
  executive_name: "",
  product_type: [], // multi-select
  from_date: null,
  to_date: null,
  applied_date_range: [],
  applied_display_date: "",
  initiated_date_range: [],
  initiated_display_date: "",
  dealer_id: [], // multi-select
  company_name: "",
  loan_type: [], // multi-select
  // Borrower Company: the borrower's employer, typed free-hand
  employer_name: "",
  // Payable (staff only): "true" -> loans the partner is paid for, "false" ->
  // the rest, "" -> no filtering. See app-js/payable-filter.js.
  payable_loan_flag: "",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
